import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.discriminatedUnion('action', [
  z.object({
    action: z.literal('deleteSession'),
    sessionId: z.string(),
  }),
  z.object({
    action: z.literal('updateUserRole'),
    userId: z.number(),
    role: z.enum(['admin', 'host', 'guest']),
  }),
  z.object({
    action: z.literal('updateSubscription'),
    userId: z.number(),
    tier: z.enum(['free', 'basic', 'pro', 'enterprise']),
    status: z.enum(['active', 'canceled', 'past_due', 'inactive', 'trialing']),
  }),
  z.object({
    action: z.literal('removeParticipant'),
    sessionId: z.string(),
    userId: z.number(),
  }),
  z.object({
    action: z.literal('archiveSession'),
    sessionId: z.string(),
  }),
  z.object({
    action: z.literal('clearPublishedUrl'),
    sessionId: z.string(),
  }),
  z.object({
    action: z.literal('deleteSite'),
    siteId: z.number(),
    cloudflareProjectName: z.string(),
  }),
  z.object({
    action: z.literal('cleanupStaleCnames'),
  }),
  z.object({
    action: z.literal('approvePartner'),
    partnerId: z.string(),
  }),
  z.object({
    action: z.literal('denyPartner'),
    partnerId: z.string(),
    reason: z.string(),
  }),
]);

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  success: boolean;
  message: string;
};

export const postTtadminAction = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const result = await fetch(`/_api/admin/ttadmin`, {
    method: 'POST',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    body: superjson.stringify(input),
  });

  if (!result.ok) {
    let errorMsg = 'Action failed';
    try {
      const errorObject = superjson.parse<{ error: string }>(await result.text());
      errorMsg = errorObject.error;
    } catch {
      try {
        const errorObject = JSON.parse(await result.text());
        errorMsg = errorObject.error || errorMsg;
      } catch {
        /* use default */
      }
    }
    throw new Error(errorMsg);
  }
  return superjson.parse<OutputType>(await result.text());
};
